import { Custom, Form } from "components";
import { useApp } from "context";

type Props = {
  users: number[];
  opened: boolean;
  onClose?: () => void;
};

export const CreateReminder = (props: Props) => {
  const { t } = useApp();

  return (
    <>
      <Custom.Modal
        header={t.title.clinic.reminder}
        opened={props.opened}
        onClose={props.onClose}
      >
        <>
          <Form.Reminder onSubmit={props.onClose} users={props.users} />
        </>
      </Custom.Modal>
    </>
  );
};
